import HttpClient from '../utility/http-client';

export default {
    cartList(page: number, rowPerPage: number, q: any) {
        const url = `/api/cart/?page=${page}&rowsPerPage=${rowPerPage}&q=${q}`;
        return HttpClient.instance().get(url);
    },

    cartByIds(ids: string) {
        const url = `/api/cart/?ids=${ids}`;
        return HttpClient.instance().get(url);
    },

    cartEdit(dataRequest: any, cartId: number) {
        const url = `/api/cart/${cartId}`;
        return HttpClient.instance().post(url, dataRequest);
    },

    cartRemoveItem(itemId: number) {
        const url = `/api/cart_detail/${itemId}`;
        return HttpClient.instance().delete(url);
    },

    cartRemoveProducts(itemIds: number[]) {
        const url = `/api/cart_detail/`;
        return HttpClient.instance().post(url, { 'ids': itemIds });
    },

    cartRemoveCarts(itemIds: number[]) {
        const url = `/api/cart/`;
        return HttpClient.instance().post(url, { 'ids': itemIds });
    },

    cartRemove(cartId: number) {
        const url = `/api/cart/${cartId}`;
        return HttpClient.instance().delete(url);
    },

    cartConfirm(itemIds: number[], otherOptions: any) {
        const url = `/api/confirm_order/`;
        return HttpClient.instance().post(url, { 'Products': itemIds, 'OtherOptions': otherOptions });
    },

    bulk_action(itemIds: number[], otherOptions: any, isDeposit: boolean, chinaStoreID, receivePlaceID) {
        const url = `/api/bulk_action/`;
        return HttpClient.instance().post(url, { 'ActionType': 'cart-deposit', 'IsDeposit': isDeposit, 'Products': itemIds,  'OtherOptions': otherOptions, 'ChinaStoreID': chinaStoreID, 'ReceivePlaceID': receivePlaceID});
    },

    finishCart(dataRequest: any) {
        const url = `/api/main_order/`;
        return HttpClient.instance().put(url, dataRequest);
    },

    searchProducts(siteName: string, searchTerm: string, isMobile: boolean) {
        const url = `/api/taobao_search/?term=${searchTerm}&site=${siteName}&mobile=${isMobile ? 1 : 0}`;
        return HttpClient.instance().get(url);
    },
};
